import { render, staticRenderFns } from "./dCustom.vue?vue&type=template&id=aaa953b0&scoped=true&"
import script from "./dCustom.vue?vue&type=script&lang=js&"
export * from "./dCustom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aaa953b0",
  null
  
)

export default component.exports